import { Phone, Mail, MapPin } from "lucide-react";

export const PhoneLink = ({ phone, className = "" }) =>
  phone ? (
    <a href={`tel:${phone}`} onClick={(e) => e.stopPropagation()}
      className={`flex items-center gap-1.5 text-muted-foreground hover:text-primary ${className}`}>
      <Phone className="h-3 w-3 shrink-0" /> {phone}
    </a>
  ) : null;

export const EmailLink = ({ email, className = "" }) =>
  email ? (
    <a href={`mailto:${email}`} onClick={(e) => e.stopPropagation()}
      className={`flex items-center gap-1.5 text-muted-foreground hover:text-primary ${className}`}>
      <Mail className="h-3 w-3 shrink-0" /> {email}
    </a>
  ) : null;

export const AddressLink = ({ address, className = "" }) =>
  address ? (
    <a href={`https://maps.google.com/?q=${encodeURIComponent(address)}`} target="_blank" rel="noreferrer"
      onClick={(e) => e.stopPropagation()}
      className={`flex items-center gap-1.5 text-muted-foreground hover:text-primary ${className}`}>
      <MapPin className="h-3 w-3 shrink-0" /> <span className="truncate">{address}</span>
    </a>
  ) : null;
